<template>
  <div v-if="$visaSomPuffar" class="col">
    <div class="listitem listpuff">
      <a :href="listItem.url" class="d-block">
        <div class="bild" v-if="listItem.image">
          <div class="background16-9">
            <div class="positioning">
              <Image
                :imageUrl="listItem.image"
                :smallWidth="516"
                :mediumWidth="630"
                :largeWidth="630"
                :altText="''"
              ></Image>
            </div>
          </div>
        </div>
        <h2 class="puffrubrik">
          <SistaOrdet :text="listItem.title" :arrowToLeft="$arrowToLeft"></SistaOrdet>
        </h2>
      </a>
      <div>
        <p class="pufftext">{{ truncateSummary }}</p>
        <div class="datum d-flex align-items-center">
          <Icon :type="'clock-o'"></Icon>
          <span aria-hidden="true">{{ listItem.publishedDate }}</span>
          <span class="visually-hidden"
            >{{ $texts.publicerad }}: {{ listItem.publishedDate }}</span
          >
        </div>
      </div>
    </div>
  </div>

  <li v-else class="listitem">
    <div class="bild" v-if="listItem.image && $visaListaMedBilder">
      <div class="background16-9">
        <div class="positioning">
          <Image
            :imageUrl="listItem.image"
            :smallWidth="515"
            :mediumWidth="240"
            :largeWidth="240"
            :altText="''"
          ></Image>
        </div>
      </div>
    </div>

    <div>
      <a :href="listItem.url">
        <SistaOrdet :text="listItem.title" :arrowToLeft="$arrowToLeft"></SistaOrdet>
      </a>
      <div class="datum d-flex align-items-center">
        <Icon :type="'clock-o'"></Icon>
        <span aria-hidden="true">{{ listItem.publishedDate }}</span>
        <span class="visually-hidden"
          >{{ $texts.publicerad }}: {{ listItem.publishedDate }}</span
        >
      </div>
      <p>{{ truncateSummary }}</p>
    </div>
  </li>
</template>

<script>
import Image from "../../image/image.vue";
import Icon from "../../image/icon.vue";
import SistaOrdet from "../../helpers/sistaordet.vue";

export default {
  name: "ListItem",
  props: {
    listItem: Object,
  },
  components: {
    Image,
    Icon,
    SistaOrdet,
  },
  computed: {
    truncateSummary() {
      if (this.listItem.summary && this.listItem.summary.length > 120) {
        return this.listItem.summary.substring(0, 119) + "...";
      } else {
        return this.listItem.summary;
      }
    },
  },
};
</script>
